module.exports = __webpack_public_path__ + "static/gradient-bg-272bab070049b44bc103215eb4ab6c43.png";